import http from 'utils/http';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';
import { getLocationsUrl, getLocationUrl } from './apiUrls';
import { Location } from './types';

export function getLocations(params: any): Promise<{ data: Location[]; meta: MetaApiResponse }> {
  return http.get(getLocationsUrl(), params);
}

export function getLocation(id: string, params?: Record<string, any>): Promise<Location> {
  return http.get(getLocationUrl(id), params);
}

export function createLocation(payload: Location): Promise<Location> {
  return http.post(getLocationsUrl(), payload);
}

export function updateLocation(id: string, payload: Location): Promise<Location> {
  return http.patch(getLocationUrl(id), payload);
}

export function deleteLocation(id: string): Promise<String> {
  return http.delete(getLocationUrl(id));
}
